import useRealtimeDocument from './use-realtime-document';

const useQuestCompletedByHowMany = (questId: string) => {
  const [result] = useRealtimeDocument<number>('quests-stats', questId);
  return result || 0;
};

export default useQuestCompletedByHowMany;
